export default "__VITE_ASSET__B37JJ6JA__"